import { IZoneCategory } from "../../../components/FacilityManager/Domain/Types/FloorPlan/ZoneCategory.type";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

export function useRemoteFetchZoneCategory(options?: { enabled?: boolean }) {
  return useRemoteQuery<IZoneCategory[]>({
    queryKey: "zone-category",
    url: "/zone-category",
    enabled: options?.enabled
  });
}
